import { Box, Chip, Container, IconButton, InputAdornment, Paper, Skeleton, Table, TableBody, TableCell, Menu as DropdownMenu, MenuItem, TableContainer, TableHead, TablePagination, TableRow, TextField, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react'
import PageLayout from '../../components/layout/PageLayout';
import {
    Visibility as ViewIcon,
    Edit as EditIcon,
    MoreVert as MoreVertIcon,
    Search as SearchIcon,
    Clear as ClearIcon
} from '@mui/icons-material';
import Can from '../../components/permissions/Can';
import { useDispatch, useSelector } from 'react-redux';
import { useAuth } from '../../hooks/useAuth';
import { getDBAs } from '../../store/slices/merchantsSlice';
import { getMerchantEquipment, getEquipmentStatuses, getEquipmentLogs, updateEquipmentStatus, deleteEquipment, clearEquipmentLogs } from '../../store/slices/equipmentSlice';
import { toast } from 'react-toastify';
import SweetAlert from '../../utils/sweetAlert';
import { extractData, extractList } from '../../utils/response';
import StatusModal from '../../components/Merchants/Modal/StatusModal';
import EquipmentHistoryModal from '../../components/Merchants/Modal/EquipmentHistoryModal';
import { useSearchParams } from 'react-router-dom';



const Equipemnts = () => {
    const [searchParams] = useSearchParams();
    const dbaId = searchParams.get('dba_id');
    const dispatch = useDispatch();
    const { hasPermission } = useAuth();
    const updateLoading = useSelector((s) => s.equipment.updateLoading);
    const statusOptions = useSelector((s) => s.equipment.statusOptions) || [];
    const equipmentLogs = useSelector((s) => s.equipment.equipmentLogs) || [];
    const logsLoading = useSelector((s) => s.equipment.logsLoading);

    const canViewMerchants = hasPermission('dba-view');
    const canEditMerchants = hasPermission('dba-edit');
    const canChangeStatus = hasPermission('dba-status');
    const canAssignDBA = hasPermission('dba-reassign');
    const canDeleteMerchants = hasPermission('dba-delete');


    const [loading, setLoading] = useState(false);
    const [searchValue, setSearchValue] = useState('');
    const [tableLoading, setTableLoading] = useState(false);
    const [pagination, setPagination] = useState({
        page: 1,
        pageSize: 10,
        total: 0,
    });
    const [dbaData, setDbaData] = useState([]);
    const [selectedUser, setSelectedUser] = useState('');
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedEquipmentForMenu, setSelectedEquipmentForMenu] = useState(null);

    // status modal 
    const [openStatusDialog, setOpenStatusDialog] = useState(false);
    const [selectedDba, setSelectedDba] = useState(null);
    const [newStatus, setNewStatus] = useState('');
    const [notes, setNotes] = useState('');
    const [sku, setSku] = useState('');
    const [gateway, setGateway] = useState('');

    // history modal
    const [openEquipmentHistory, setOpenEquipmentHistory] = useState(false);

    const handleSearchChange = (e) => {
        setSearchValue(e.target.value);
    };

    // Clear search
    const handleClearSearch = () => {
        setSearchValue('');
    };

    const handlePageChange = (newPage) => {
        setPagination(prev => ({ ...prev, page: newPage }));
    };

    const handleRowsPerPageChange = (newSize) => {
        setPagination({ page: 1, pageSize: newSize, total: pagination.total });
    };

    // for now 
    const loadequipmentsList = async (page = pagination.page,
        pageSize = pagination.pageSize,
        search = searchValue) => {
        if (!canViewMerchants) {
            toast.error('You do not have permission to view merchants.');
            return;
        }
        try {
            setTableLoading(true);
            const params = {
                'dba_id': dbaId,               // ← this is what the API expects
                paginate: 1,
                page,
                per_page: pageSize,
                ...(search && { search }),
            };
            const response = await dispatch(getMerchantEquipment(params)).unwrap();
            setDbaData(extractData(response) || response?.data || []);
            console.log(dbaData, '22 last');
            
            setPagination(prev => ({
                ...prev,
                total: response?.data?.pagination?.total || 0
            }));
        } catch (error) {
            console.error('Error loading DBA data:', error);
            toast.error('Failed to load DBA data. Please try again.');
        } finally {
            setTableLoading(false);
        }
    };

    // mdoal js
    const handleCloseStatusDialog = () => {
        setOpenStatusDialog(false);

        // Optional: clean up form values after modal closes
        setTimeout(() => {
            setSelectedDba(null);
            setNewStatus('');
            setNotes('');
            setSku('');
            setGateway('');
        }, 300); // small delay to avoid flash
    };

    const handleOpenStatusChange = (equipment) => {
        setSelectedDba(equipment);
        setNewStatus('');
        setNotes('');
        setSku(equipment?.sku_number ?? '');
        setGateway('');
        setOpenStatusDialog(true);
    };

    const handleChangeStatus = async () => {
        if (!selectedDba || !newStatus) return;

        const equipmentId = selectedDba.id;
        const payload = {
            status_id: newStatus,
            note: notes || '',
            sku_number: sku || '',
        };

        try {
            await dispatch(updateEquipmentStatus({ equipmentId, payload })).unwrap();
            toast.success('Equipment status updated successfully.');
            handleCloseStatusDialog();
            loadequipmentsList();
        } catch (err) {
            toast.error(err?.message || err || 'Failed to update equipment status.');
        }
    };




    // history


    const handleOpenHistory = async (equipment) => {
        if (!equipment?.id) {
            toast.error('No equipment selected.');
            return;
        }
        setOpenEquipmentHistory(true);
        try {
            console.log(equipment.id, 'equipment.id');
            await dispatch(getEquipmentLogs(equipment.id)).unwrap();
            console.log(equipmentLogs, 'equipmentLogs');
        } catch (err) {
            toast.error(err?.message || err || 'Failed to load equipment history.');
            dispatch(clearEquipmentLogs());
        }
    };

    const handleCloseEquipmentHistory = () => {
        setOpenEquipmentHistory(false);
        dispatch(clearEquipmentLogs());
    };

    const handleDeleteEquipment = async (equipment) => {
        if (!equipment?.id) {
            toast.error('No equipment selected.');
            return;
        }
        if (!canDeleteMerchants) {
            toast.error('You do not have permission to delete equipment.');
            return;
        }
        const itemName = equipment?.equipment_model?.name || equipment?.manufacturer?.name || 'this equipment';
        const result = await SweetAlert.deleteConfirm(itemName);
        if (!result?.isConfirmed) return;
        try {
            await dispatch(deleteEquipment(equipment.id)).unwrap();
            toast.success('Equipment deleted successfully.');
            setAnchorEl(null);
            setSelectedEquipmentForMenu(null);
            loadequipmentsList();
        } catch (err) {
            toast.error(err?.message || err || 'Failed to delete equipment.');
        }
    };




    useEffect(() => {
        dispatch(getEquipmentStatuses());
    }, [dispatch]);

    useEffect(() => {
        loadequipmentsList();
    }, [searchValue, pagination.page, pagination.pageSize, selectedUser]);


    return (
        <PageLayout>
            <Container maxWidth="xl" sx={{ py: 3 }}>
                <Box sx={{ mb: 3, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    {loading ? (
                        <Skeleton variant="text" width={200} height={40} />
                    ) : (
                        <Typography
                            variant="h4"
                            sx={{ color: '#154A8A', fontWeight: 600 }}
                        >
                            Merhants Equipments list
                        </Typography>
                    )}

                    {loading ? (
                        <Skeleton variant="rectangular" width={300} height={40} />
                    ) : (
                        <TextField
                            placeholder="Search by Merchant DBA"
                            value={searchValue}
                            onChange={handleSearchChange}
                            sx={{ width: 300 }}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon color="action" />
                                    </InputAdornment>
                                ),
                                endAdornment: searchValue && (
                                    <InputAdornment position="end">
                                        <IconButton
                                            size="small"
                                            onClick={handleClearSearch}
                                            edge="end"
                                        >
                                            <ClearIcon />
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                        />
                    )}
                </Box>


                {/* jango */}

                <Paper sx={{ boxShadow: 1 }}>
                    <TableContainer>
                        <Table>
                            <TableHead>
                                <TableRow sx={{ bgcolor: 'grey.100' }}>
                                    <TableCell sx={{ fontWeight: 600, color: 'grey.700' }}>
                                        S.No
                                    </TableCell>
                                    <TableCell sx={{ fontWeight: 600, color: 'grey.700' }}>
                                        Manufacturer
                                    </TableCell>
                                    <TableCell sx={{ fontWeight: 600, color: 'grey.700' }}>
                                        Equipment Type
                                    </TableCell>
                                    <TableCell sx={{ fontWeight: 600, color: 'grey.700' }}>
                                        Equipment Model
                                    </TableCell>
                                    <TableCell sx={{ fontWeight: 600, color: 'grey.700' }}>
                                        Status
                                    </TableCell>
                                    <TableCell sx={{ fontWeight: 600, color: 'grey.700' }}>
                                        SKU Number
                                    </TableCell>
                                    <TableCell sx={{ fontWeight: 600, color: 'grey.700' }}>
                                        Last Note
                                    </TableCell>
                                    <TableCell sx={{ fontWeight: 600, color: 'grey.700', textAlign: 'center' }}>Actions</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {tableLoading ? (
                                    // Skeleton loading rows
                                    [...Array(pagination.pageSize)].map((_, index) => (
                                        <TableRow key={index}>
                                            <TableCell><Skeleton animation="wave" height={30} /></TableCell>
                                            <TableCell><Skeleton animation="wave" height={30} /></TableCell>
                                            <TableCell><Skeleton animation="wave" height={30} /></TableCell>
                                            <TableCell><Skeleton animation="wave" height={30} /></TableCell>
                                            <TableCell><Skeleton animation="wave" height={30} /></TableCell>
                                            <TableCell><Skeleton animation="wave" height={30} /></TableCell>
                                            <TableCell><Skeleton animation="wave" height={30} width={80} /></TableCell>
                                            <TableCell sx={{ textAlign: 'center' }}><Skeleton animation="wave" height={30} width={40} /></TableCell>
                                        </TableRow>
                                    ))
                                ) : dbaData.length === 0 ? (
                                    <TableRow>
                                        <TableCell colSpan={7} sx={{ textAlign: 'center', py: 4 }}>
                                            <Typography variant="body1" color="text.secondary">
                                                {searchValue ? 'No records found for your search' : "There's no records to display"}
                                            </Typography>
                                        </TableCell>
                                    </TableRow>
                                ) : (
                                    dbaData?.map((dba) => (
                                        <TableRow key={dba.id} hover>
                                            <TableCell>{dba?.manufacturer?.name || 'N/A'}</TableCell>
                                            <TableCell>{dba?.manufacturer?.name || 'N/A'}</TableCell>
                                            <TableCell>{dba?.equipment_type?.name || 'N/A'}</TableCell>
                                            <TableCell>{dba?.equipment_model?.name || 'N/A'}</TableCell>
                                            <TableCell>
                                                <Chip
                                                    label={dba?.equipment_last_Log?.status?.name || 'undefine'}
                                                    color={dba?.equipment_last_Log?.status?.name === 'Completed' ? 'success' : dba?.equipment_last_Log?.status?.name === 'Underwriting' ? 'warning' : 'default'}
                                                    size="small"
                                                />
                                            </TableCell>
                                            <TableCell>{dba?.sku_number ?? "not available"}</TableCell>
                                            <TableCell>{dba?.equipment_last_Log?.note ?? "not available"}</TableCell>

                                            <TableCell sx={{ textAlign: 'center' }}>
                                                <Can permission="dba-view" fallback={<Box sx={{ width: 40, display: 'inline-block' }} />}>
                                                    <IconButton
                                                        onClick={(event) => {
                                                            setSelectedEquipmentForMenu(dba);
                                                            setAnchorEl(event.currentTarget);
                                                        }}
                                                    >
                                                        <MoreVertIcon />
                                                    </IconButton>
                                                </Can>
                                            </TableCell>
                                        </TableRow>
                                    ))
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>

                    {/* Pagination */}
                    {!tableLoading && dbaData.length > 0 && (
                        <TablePagination
                            component="div"
                            count={pagination.total}
                            page={pagination.page - 1}
                            onPageChange={(_, newPage) => {
                                handlePageChange(newPage + 1);
                            }}
                            rowsPerPage={pagination.pageSize}
                            onRowsPerPageChange={(e) => {
                                handleRowsPerPageChange(Number(e.target.value));
                            }}
                            rowsPerPageOptions={[5, 10, 25, 50]}
                            labelRowsPerPage="Rows per page"
                        />
                    )}
                </Paper>

                <DropdownMenu
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={() => { setAnchorEl(null); setSelectedEquipmentForMenu(null); }}
                >
                    <Can permission="dba-status">
                        <MenuItem
                            onClick={() => {
                                if (selectedEquipmentForMenu) handleOpenStatusChange(selectedEquipmentForMenu);
                                setAnchorEl(null);
                            }}
                        >
                            Change Equipment Status
                        </MenuItem>
                    </Can>

                    <Can permission="dba-view">
                        <MenuItem onClick={() => {
                            handleOpenHistory(selectedEquipmentForMenu);
                            setAnchorEl(null);
                        }}>
                            Show Equipment History
                        </MenuItem>
                    </Can>

                    <Can permission="dba-delete">
                        <MenuItem
                            onClick={() => {
                                setAnchorEl(null);
                                if (selectedEquipmentForMenu) handleDeleteEquipment(selectedEquipmentForMenu);
                            }}
                            sx={{ color: 'error.main' }}
                        >
                            Delete
                        </MenuItem>
                    </Can>
                </DropdownMenu>
                {/* end of jango  */}

                {/* modal implement */}
                <StatusModal
                    open={openStatusDialog}
                    onClose={handleCloseStatusDialog}
                    selectedDba={selectedDba}
                    newStatus={newStatus}
                    onStatusChange={(e) => setNewStatus(e.target.value)}
                    notes={notes}
                    onNotesChange={(e) => setNotes(e.target.value)}
                    sku={sku}
                    onSkuChange={(e) => setSku(e.target.value)}
                    gateway={gateway}
                    onGatewayChange={(e) => setGateway(e.target.value)}
                    showNotes={true}
                    showSku={true}
                    onConfirm={handleChangeStatus}
                    statusOptions={statusOptions.map((s) => ({ id: s.id ?? s.uuid, name: s.name ?? s.label ?? String(s.id ?? s.uuid) }))}
                    processing={updateLoading}
                    title="Change Equipment Status"
                    description="Select the new status and add SKU or notes if needed."
                />

                {/*  equipment history*/}
                <EquipmentHistoryModal
                    open={openEquipmentHistory}
                    onClose={handleCloseEquipmentHistory}
                    historyLogs={equipmentLogs}
                    loading={logsLoading}
                    title="Equipment History"
                    emptyMessage="No history records found"
                />

            </Container>

        </PageLayout>
    )
}

export default Equipemnts